<template>
  <el-scrollbar v-bind="$props" :class="generateClass">
    <slot/>
  </el-scrollbar>
</template>

<script>
  import {Scrollbar} from 'element-ui'

  export default {
    components: {
      'el-scrollbar': Scrollbar
    },
    props: {
      ...Scrollbar.props,
      vertical: {
        type: Boolean,
        default: true
      },
      horizontal: {
        type: Boolean,
        default: false
      }
    },
    computed: {
      generateClass () {
        let prefix = 'abp-scrollbar'
        let c = ''
        if (this.vertical) c += prefix + '--vertical '
        if (this.horizontal) c += prefix + '--horizontal'
        return c
      }
    }
  }
</script>

<style lang="scss">
  $child-class: '.el-scrollbar__wrap';

  .abp-scrollbar {
    height: 100%;
    -webkit-overflow-scrolling: touch;

    &--vertical #{$child-class} {
      overflow-x: auto;
    }

    &--horizontal #{$child-class} {
      overflow-y: auto;
    }
  }
</style>
